import { useState, useEffect } from "react";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useRoles = () => {
  const [roles, setRoles] = useState([]);
  useEffect(() => {
    let alive = true;
    fetch(`${API}/careers/roles`).then((r) => r.json()).then((d) => alive && setRoles(d.roles || [])).catch(() => {});
    return () => { alive = false; };
  }, []);
  return roles;
};
